import { render } from "./CMultiSelect.vue?vue&type=template&id=272d14e6"
import script from "./CMultiSelect.vue?vue&type=script&lang=js"
export * from "./CMultiSelect.vue?vue&type=script&lang=js"

import "./CMultiSelect.vue?vue&type=style&index=0&id=272d14e6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__